import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import moment from 'moment';
import * as jobActions from 'actions/jobActions';
import * as clientDetailsActions from '../../actions/clientDetailsActions'; //'actions/clientDetailsActions';
import * as jobLocationActions from 'actions/jobLocationActions';
import * as formActions from 'actions/formActions';
import { getJobTypeById } from 'selectors/formSelectors';
import {
  getDefaultStandard,
  getDefaultDestination,
  getDefaultTreatmentType,
  getDefaultCommodity,
} from '../../selectors/referenceDataSelectors';
import JobDetailsCreatePage from './JobDetailsCreatePage';
import { useParams, useNavigate } from 'react-router-dom';
import { defaults } from 'lodash';
//import { jobDetailsForm } from '../../constants/FormConstants';

const JobDetailsCreatePageContainer = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const jobType = useSelector((state) => getJobTypeById(state,id));
  const jobType = useSelector((state) => {
    return getJobTypeById(state, id);
  });

  const defaultStd = useSelector((state) => {
    return getDefaultStandard(state, id);
  });

  const defaultDestination = useSelector((state) => {
    return getDefaultDestination(state, id);
  });

  const defaultTreatmentType = useSelector((state) => {
    return getDefaultTreatmentType(state, id);
  });

  const defaultCommodity = useSelector((state) => {
    return getDefaultCommodity(state, id);
  });

  // Fetch state using selectors
  const initialValues = useSelector((state) => {
    return {
      dateOfRequest: moment().startOf('day'),
      jobType: jobType,
      typeId: id,
      jobWorkflowId: '14a71deb-3807-4607-bba0-92d1b612ec97',
      treatmentDetails: {
        standardId: defaultStd, // getDefaultStandard(state),
        treatmentTypeId: defaultTreatmentType, //getDefaultTreatmentType(state),
      },
      treatmentTypeDetails: {
        destination: defaultDestination, //getDefaultDestination(state), // getDefaultDestinationNew(state, jobType), //
        commodity: defaultCommodity, //getDefaultCommodity(state),
      },
      newNoticeOfIntendedTreatment: {
        sendNotice: true,
      },
    };
  });

  // Bind action creators
  const actions = bindActionCreators(
    {
      ...jobActions,
      ...clientDetailsActions,
      ...jobLocationActions,
      ...formActions,
    },
    dispatch,
  );

  return (
    <JobDetailsCreatePage
      initialValues={initialValues}
      jobType={jobType}
      actions={actions}
      navigate={navigate}
    />
  );
};

// Enhance with redux-form
export default JobDetailsCreatePageContainer;
